import React, { createRef } from "react";

import Lottie from "react-lottie";
import animationData from "./Loader.json";

// Redux
import { useSelector } from "react-redux";

// MUI
import Dialog from "@mui/material/Dialog";

const Spinner = () => {
  const open = useSelector((state) => state.spinner.networkProgressDialog);
  const ref = createRef();

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <Dialog
      open={open}
      disableEscapeKeyDown
      PaperComponent="div"
      ref={ref}
      hideBackdrop
      PaperProps={{
        sx: {
          background: "transparent !important",
          backgroundColor: "transparent !important",
          border: "none !important",
          boxShadow: "none !important",
          borderRadius: "0 !important",
          overflow: "visible !important",
          backdropFilter: "none !important",
          WebkitBackdropFilter: "none !important",
          padding: 0,
          margin: 0,
        },
      }}
      sx={{
        "& .MuiDialog-paper": {
          background: "transparent !important",
          backgroundColor: "transparent !important",
          border: "none !important",
          boxShadow: "none !important",
          borderRadius: "0 !important",
          overflow: "visible !important",
          backdropFilter: "none !important",
        },
      }}
    >
      <Lottie options={defaultOptions} height={130} width={130} />
    </Dialog>
  );
};

export default React.memo(Spinner);
